export function scrollStop(refresh = 100) {
    let isScrolling;
    return (callback) => {
        clearTimeout(isScrolling);
        isScrolling = setTimeout(callback, refresh);
    };
}
export function scrollSpeed(refresh = 200) {
    let lastScrollPosition = undefined;
    let isScrollingFast;
    return (size, callback) => (scrollPosition) => {
        if (!lastScrollPosition) {
            lastScrollPosition = scrollPosition;
        }
        else {
            if (Math.abs(scrollPosition - lastScrollPosition) > size) {
                callback.fast();
                if (isScrollingFast !== undefined) {
                    clearTimeout(isScrollingFast);
                    isScrollingFast = undefined;
                }
                isScrollingFast = setTimeout(() => {
                    callback.slow();
                    isScrollingFast = undefined;
                }, refresh);
            }
            else {
                if (isScrollingFast === undefined) {
                    callback.slow();
                }
            }
            lastScrollPosition = scrollPosition;
        }
    };
}
